import PropTypes from 'prop-types'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { adjuntoBuilder } from '../reutilizables/upload/adjuntoBuilder'
import { DescargarExcelVentas } from '../servicios/descargarExcel'

export const DescargarExcel = ({ fechaDesde, fechaHasta, filtrosFijos, esAdministrador }) => {
  const { loginDataContext: { idUsuario } = {} } = useAuth()
  const getFiltro = (titulo) => filtrosFijos.find((f) => f.titulo === titulo)?.value

  const descargaExcel = async () => {
    try {
      const body = {
        fechaDesde,
        fechaHasta,
        idVendedor: esAdministrador ? getFiltro('Vendedor') : idUsuario,
        comprador: getFiltro('Comprador'),
        estadoPago: getFiltro('Estado del pago'),
        estadoEnvio: getFiltro('Estado del envío'),
        includeVendedor: !!esAdministrador,
        titulo: esAdministrador ? 'Todas las Ventas EBM' : 'Mis Ventas'
      }
      const { data: excel } = await DescargarExcelVentas(body)
      await adjuntoBuilder(excel, null, 'Pedidos', { isBase64: false })
    } catch (error) {
      const mensaje = `Ocurrió un error al descargar el Excel.`
      toastErrorLog(error, mensaje, 'Descarga de Excel')
    }
  }

  return (
    <button className="btn btn-info" onClick={() => descargaExcel()}>
      <i className="bi bi-file-earmark-excel me-2"></i>
      Descargar pedidos
    </button>
  )
}
DescargarExcel.propTypes = {
  fechaDesde: PropTypes.string.isRequired,
  fechaHasta: PropTypes.string.isRequired,
  idVendedor: PropTypes.integer,
  filtrosFijos: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number
    })
  ),
  esAdministrador: PropTypes.bool
}
